module.exports = __webpack_public_path__ + "img/income-bg.31c1e7ab.png";